import React from 'react';
import classnames from 'classnames';
import { Select } from 'tea-component';

import './index.scss';
// changeValue: 选择的值
// optionsList: 数据的列表
// labelValue:     标签文字
// className:      类名
// getSelectMultiple: 获取选中的值
// listHeight:    列表高度
// searchable:   是否有搜索
// disabled：是否禁用
// labelIcon:    标签图标
const SelectChoice = (porps: any) => {
  const {
    changeValue,
    optionsList,
    labelValue,
    className,
    overlayClassName,
    getSelectMultiple,
    listHeight,
    searchable,
    searchPlaceholder,
    autoClearSearchValue,
    filter,
    disabled,
    labelIcon,
    array,
    listWidth = 240,
  } = porps;

  return (
    <Select
      className={classnames('dbi-select-choice', className)}
      overlayClassName={classnames('dbi-select-choice-overlay', overlayClassName)}
      matchButtonWidth
      size="m"
      style={{ width: listWidth }}
      listHeight={listHeight ? listHeight : 400}
      appearance="button"
      searchable={Boolean(searchable)}
      searchPlaceholder={searchPlaceholder}
      autoClearSearchValue={autoClearSearchValue}
      filter={filter}
      disabled={Boolean(disabled)}
      value={changeValue}
      onChange={(value) => getSelectMultiple(value)}
      options={optionsList}
      button={(option) => (

        <div className="dbi-select-button">
          <div className="dbi-select-button-text">
            {labelIcon ? (
              <img src={labelIcon} className="dbi-select-tipIcon" />
            ) : (
              ''
            )}
            {labelValue}
          </div>
          <div className="dbi-select-row">{option?.text ? option.text : ''}</div>
        </div>
      )}
      {...array}
    />
  );
};

export default SelectChoice;
